/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_product = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt`
};

const da_product = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt`
};

const de_product = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt`
};

const en_product = /** @type {(inputs: {}) => string} */ () => {
	return `Product`
};

const es_product = /** @type {(inputs: {}) => string} */ () => {
	return `Producto`
};

const fr_product = /** @type {(inputs: {}) => string} */ () => {
	return `Produit`
};

const hu_product = /** @type {(inputs: {}) => string} */ () => {
	return `Termék`
};

const it_product = /** @type {(inputs: {}) => string} */ () => {
	return `Prodotto`
};

const nl_product = /** @type {(inputs: {}) => string} */ () => {
	return `Product`
};

const pl_product = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt`
};

const pt_product = /** @type {(inputs: {}) => string} */ () => {
	return `Produto`
};

const sv_product = /** @type {(inputs: {}) => string} */ () => {
	return `Produkt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const product = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.product(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("product", locale)
	if (locale === "cs") return cs_product(inputs)
	if (locale === "da") return da_product(inputs)
	if (locale === "de") return de_product(inputs)
	if (locale === "en") return en_product(inputs)
	if (locale === "es") return es_product(inputs)
	if (locale === "fr") return fr_product(inputs)
	if (locale === "hu") return hu_product(inputs)
	if (locale === "it") return it_product(inputs)
	if (locale === "nl") return nl_product(inputs)
	if (locale === "pl") return pl_product(inputs)
	if (locale === "pt") return pt_product(inputs)
	return sv_product(inputs)
};